export const schemaOrg = {
  organization: {
    "@type": "Organization",
    "name": "CountLike.PRO",
    "description": "An online toolbox with a variety of calculators and converters for various needs",
    "url": "https://countlike.pro",
    "logo": "https://countlike.pro/favicon.svg",
  },
  authorAlexFedorov: {
    "@type": "Person",
    "name": "Alex Fedorov",
    "image": "https://static.countlike.pro/Alex-Fedorov.webp",
  }
};

/**
 * https://developers.google.com/search/docs/appearance/structured-data/article?hl=ru
 */
export function createArticleSchema(
  locale: string,
  title: string,
  images: string[],
  dateModified: Date|null = null,
  author: object = schemaOrg.organization,
) {
  return  {
    "script:ld+json": {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": title,
      "image": images,
      "inLanguage": locale,
      "author": [author],
      "dateModified": dateModified ? dateModified.toISOString() : undefined
    }
  };
}